import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { IMeeting } from 'src/interfaces/IMeeting';

export interface RecordingState {
  recordings: IMeeting[];
  recording: IMeeting | undefined;
  lastSynced: number;
  lastKey?: { account_number: any; sk: string } | null;
}

const initialState: RecordingState = {
  recordings: [],
  recording: undefined,
  lastSynced: 0,
  lastKey: null,
};

export const recordingSlice = createSlice({
  name: 'recording',
  initialState,
  reducers: {
    setRecordings: (state, action: PayloadAction<IMeeting[]>) => {
      state.recordings = action.payload
      state.lastKey = { account_number: action.payload[action.payload.length - 1].account_number, sk: action.payload[action.payload.length - 1].sk };
    },
    appendRecordings: (state, action: PayloadAction<IMeeting[]>) => {
      state.recordings = [...state.recordings, ...action.payload]
      state.lastKey = { account_number: action.payload[action.payload.length - 1].account_number, sk: action.payload[action.payload.length - 1].sk };
      
    },
    setRecording: (state, action: PayloadAction<IMeeting>) => {
      state.recording = action.payload
    },
    updateRecording: (state, action: PayloadAction<IMeeting>) => {
      const { payload } = action;
      state.recordings = state.recordings.map(i => {
        if (i.uuid !== payload.uuid) return i;
        return payload;
      })
    },
    setLastSynced: (state, action: PayloadAction<number>) => {
      state.lastSynced = action.payload
    }
  }
});

export const { appendRecordings, setRecordings, updateRecording, setRecording, setLastSynced } = recordingSlice.actions;

export default recordingSlice.reducer;

export const fetchRecordingList = {
  eventName: 'Fetch Recordings List',
  onSuccess: [{ redux: true, action: setRecordings }]
}

export const paginateRecordingList = {
  eventName: 'Fetch Recordings List',
  onSuccess: [{ redux: true, action: appendRecordings }]
}

export const fetchRecording = {
  eventName: 'Fetch Recording',
  onSuccess: [{ redux: true, action: setRecording }]
}

export const synchronizeAccountRecordings = {
  eventName: 'Synchronize Account Recordings',
  onSuccess: [{ redux: true, action: setLastSynced }],
}
